<template>
	<div class="helpLink">
		<div @click="openTo">
			<ig-icon name="bangzhuzhongxin" class="icon"></ig-icon
			><span class="text">&nbsp&nbsp帮助中心</span>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			url: 'https://docs.qq.com/doc/p/24f0f1f1bf1c66343ef7e9a9e67c5edf4d9ffd4c?dver=3.0.27554990',
			target: {
				default: '_blank',
			},
		};
	},

	methods: {
		openTo() {
			this.$router.push({
				path: '/helpSeting',
			});
			// window.open(this.url, this.target);
		},
	},
};
</script>

<style lang="scss" scoped>
.helpLink {
	display: inline-block;
	font-size: 14px;
	color: #333333;
	.icon {
		color: #606266;
		font-size: 15px;
		cursor: pointer;
	}
	.text {
		border-right: 1px #606266 solid;
		padding-right: 20px;
	}
}
</style>
